import React from 'react';
import { Row, Col, Switch, Typography } from 'antd';

const { Text } = Typography;

export function SwitchCustom({
  change = () => {},
  checked,
  size = 'default',
  color = '#24A95D',
  title,
  fontSize = '18px',
  reverse = false,
  ...props
}) {
  const onChange = check => change(check);
  return (
    <Row
      justify="end"
      align="center"
      style={{
        justifyContent: 'center',
        flexDirection: reverse ? 'row-reverse' : 'row',
      }}
    >
      <Col>
        <Switch {...props} onChange={onChange} checked={checked} size={size} />
      </Col>
      <Col
        style={{
          marginLeft: 20,
        }}
      >
        <Text
          style={{
            fontWeight: 'bold',
            fontSize,
            lineHeight: '16px',
            color,
            marginRight: reverse ? 26 : 0,
          }}
        >
          {title || ''}
        </Text>
      </Col>
    </Row>
  );
}
